<template>
  <div class="rate_list_box padding-md text-white">
    <div v-if="$route.path.lastIndexOf('/') === 0">
      <!-- 搜索框 -->
      <div class="box-card">
        <div class="text item">
          <el-form inline class="padding-top margin-sm-bottom">
            <el-form-item label="客户名称">
              <el-input
                v-model="searchForm.companyName"
                style="width: 250px"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button
                class="btn-purple"
                icon="el-icon-search"
                :disabled="role >= 1 ? true : false"
                @click="queryCustomer()"
                v-preventReClick
                >{{ $t("siteList.checkButton") }}</el-button
              >
              <el-button
                class="btn-green"
                icon="el-icon-plus"
                @click="onAdd(1)"
                v-auth="btnAuth.add"
                >{{ $t("deviceList.addEquipment") }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 站点数据信息展示表格 -->
      <div class="table-box">
        <el-table
          :data="CustomerData"
          style="width: 100%"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ 'text-align': 'center' }"
          :row-class-name="tableRowClassName"
          :row-style="{ height: '60px' }"
        >
          <el-table-column label="客户ID" prop="id" width="80">
          </el-table-column>
          <el-table-column label="公司名称" prop="companyName">
          </el-table-column>
          <el-table-column label="联系人" prop="contacts"> </el-table-column>
          <el-table-column label="公司简称" prop="shortName"> </el-table-column>
          <el-table-column label="地址" prop="address"> </el-table-column>
          <el-table-column label="创建时间" prop="createTime">
          </el-table-column>
          <el-table-column :label="$t('deviceList.operation')" width="100">
            <!-- 操作按钮 -->
            <template v-slot="{ row }">
              <div class="flex items-middle space-around">
                <el-button
                  class="text-red"
                  type="text"
                  @click="onDelete(row)"
                  v-auth="btnAuth.delete"
                  size="mini"
                >
                  <icon
                    type="icon-wendang-caogao-F"
                    color="#234659"
                    size="25"
                  ></icon
                ></el-button>
                <el-button
                  class="text-red"
                  type="text"
                  @click="onAdd(2, row)"
                  v-auth="btnAuth.edit"
                  size="mini"
                >
                  <icon type="icon-shanchu1-F" color="#234659" size="25"></icon
                ></el-button>
                <!-- <el-button
                  class="text-blue"
                  type="text"
                  @click="onAdd(2, row)"
                  v-auth="btnAuth.edit"
                  icon="el-icon-edit"
                  size="mini"
                  >{{ $t("deviceList.editInfo") }}</el-button
                > -->
                <!-- <div>
                  <i class="el-icon-view"></i>
                  <el-button
                    class="text-blue"
                    type="text"
                    @click="onAdd(3, row)"
                    >查看</el-button
                  >
                </div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 翻页 -->
        <div class="block" style="margin-top: 15px">
          <pagination
            :total="countNum"
            v-on:getCurrent="changeCurrent"
            v-on:getPageSize="changePage"
          ></pagination>
        </div>
      </div>
    </div>
    <customer-update
      ref="customerUpdate"
      @refresh="getCustomer"
    ></customer-update>
  </div>
</template>

<script>
import pagination from "../../components/pagination.vue";
import { customerQuery, customerDel } from "../../api/customer";
// import DeviceInfo from "../../components/deviceInfo.vue";
import i18n from "@/lang";
import CustomerUpdate from "./components/customerUpdate.vue";
import Icon from "../../components/Icon.vue";
export default {
  components: { pagination, CustomerUpdate, Icon },
  data() {
    return {
      searchForm: {
        companyName: "",
      },
      CustomerData: [],
      searchRules: {
        siteId: [
          { required: false, message: "请输入站点ID", trigger: "blur" },
          {
            pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/,
            message: "用户ID以字母开头，且只能包含英文字母、数字、下划线",
          },
        ],
      },
      object: {
        pageNumber: 1,
        pageSize: 10,
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页的数据条数
      role: 0, //角色
      countNum: 0,
      btnAuth: {
        add: "customerAdd",
        delete: "customerDelete",
        edit: "customerEdit",
      },
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getCustomer();
    },
    queryCustomer() {
      let obj = {
        pageNumber: this.object.pageNumber,
        pageSize: this.object.pageSize,
        para: {
          companyName: this.searchForm.companyName,
        },
      };
      // console.log(obj);
      customerQuery(obj).then((res) => {
        if (res.data.data.list.length == 0) {
          this.$message({
            type: "warning",
            message: "暂无结果",
          });
        } else {
          this.countNum = res.data.data.countNum;
          this.CustomerData = res.data.data.list;
        }
      });
    },
    getCustomer() {
      // console.log(obj);
      customerQuery(this.object)
        .then((res) => {
          console.log(res.data.data.list);
          this.countNum = res.data.data.countNum;
          this.CustomerData = res.data.data.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onAdd(type, row = {}) {
      this.$refs.customerUpdate.open(type, row);
    },
    onDelete(row) {
      console.log(row.id);
      this.$confirm(
        i18n.t("prompt.deletePromptInfo"),
        i18n.t("prompt.promptInfo"),
        {
          confirmButtonText: i18n.t("prompt.confirm"),
          cancelButtonText: i18n.t("prompt.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          customerDel({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: i18n.t("prompt.operateSuccessfully"),
              });
              this.getCustomer();
            } else {
              this.$message({
                type: "error",
                message: i18n.t("prompt.operationFailure") + res.data.message,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: i18n.t("prompt.OperationCancelled"),
          });
        });
    },
    changeCurrent(data) {
      this.object.pageNumber = data;
      this.currentPage = data;
      console.log(this.object);
      this.getCustomer();
    },
    changePage(data) {
      this.object.pageSize = data;
      this.pageSize = data;
      console.log(this.object);
      this.getCustomer();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "";
      } else {
        return "warning-row";
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.rate_list_box{
    width: 100%;
    box-sizing: border-box;
    height: calc(100vh - 130px);
    overflow: auto;
}
.table-box{
  padding: 20px;
    // background: linear-gradient(45deg, #35478a, #162257);
    background: #102135
    border-radius: 10px;
}
.table-add{
  margin-bottom: 20px
}
/deep/.el-table, .el-table tr, .el-table td, .el-table th {
    background-color: transparent!important;
}

// 表格斑马自定义颜色
::v-deep .el-table__row.warning-row {
  background: #17273b !important;
}
::v-deep .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 1px solid #27344b
}
</style>
